import React from 'react'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import UseChat from '../../utils/useChat'
import { Link } from 'react-router-dom'
import GetUser from '../../utils/getUser'

interface IChatIcon {
    isCustomer?: boolean
}

const ChatIcon: React.FC<IChatIcon> = ({ isCustomer }) => {
    const { unReadMessageCount } = UseChat()
    const user = GetUser()

    return (
        <Link to={isCustomer ? `/chat?customerCode=${user?.code}` : '/chat'}>
            <div className="relative h-10 w-10 rounded-full flex items-center justify-center bg-surface border border-edge text-light-gray hover:text-text-primary hover:border-indigo-400/40 outline-none cursor-pointer transition-all duration-200">
                {unReadMessageCount ? <div className="min-w-[18px] px-1.5 py-[1px] bg-gradient-to-r from-accent to-accent-bright shadow-glow-sm rounded-full text-white absolute -top-1.5 -right-1.5 text-[10px] font-semibold tabular-nums text-center">{unReadMessageCount}</div> : null}
                <FontAwesomeIcon icon={faEnvelope} className="text-[15px]" />
            </div>
        </Link>
    )
}

export default ChatIcon
